/**
 * Le widget du test d'humanité, rendu seulement s'il est allumé.
 *
 * Sans clé configurée, ce composant ne rend rien et ne charge aucun script :
 * c'est l'état normal aujourd'hui. Voir `lib/testHumain.ts` pour la raison
 * d'avoir posé la plomberie avant d'en avoir besoin.
 */
import { useEffect, useRef } from "react";
import { chargerTestHumain, cleTestHumain } from "@/lib/testHumain";

export function TestHumain({
  onJeton,
  language,
}: {
  onJeton: (jeton: string | null) => void;
  language?: string;
}) {
  const boite = useRef<HTMLDivElement>(null);
  // Le rappel change à chaque rendu du parent ; sans cette référence, le widget
  // serait détruit et reconstruit en boucle, et Cloudflare finirait par voir un
  // comportement de robot là où il n'y a qu'un effet mal écrit.
  const rappel = useRef(onJeton);
  rappel.current = onJeton;

  useEffect(() => {
    if (!cleTestHumain()) return;
    let idWidget: string | null = null;
    let vivant = true;

    chargerTestHumain().then((turnstile) => {
      if (!vivant || !turnstile || !boite.current) {
        // Script injoignable : on laisse passer, comme le serveur le fait
        // quand Cloudflare ne répond pas.
        if (vivant && !turnstile) rappel.current(null);
        return;
      }
      idWidget = turnstile.render(boite.current, {
        sitekey: cleTestHumain()!,
        callback: (jeton) => rappel.current(jeton),
        "error-callback": () => rappel.current(null),
        "expired-callback": () => rappel.current(null),
        // Ne se montre que si Cloudflare doute : la quasi-totalité des gens
        // ne verront jamais ce composant.
        appearance: "interaction-only",
        language,
      });
    });

    return () => {
      vivant = false;
      if (idWidget && window.turnstile) window.turnstile.remove(idWidget);
    };
  }, [language]);

  if (!cleTestHumain()) return null;
  return <div ref={boite} className="mb-4 flex justify-center" />;
}
